import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { applyHeights } from "@/utils/calculateHeight";
// 初始化高度
// applyHeights();

// 监听窗口大小变化
// window.addEventListener("resize", applyHeights);
import "amfe-flexible";

import intro from "intro.js"; // introjs库
import "intro.js/introjs.css"; // introjs默认css样式
// introjs还提供了多种主题，可以通过以下方式引入
import "intro.js/themes/introjs-modern.css"; // introjs主题
// 加载全局样式  【增加这一句】
import "./styles/index.less";
// 引入字体样式
import "@/styles/font.css";

import { getShareInfo, getTxtData } from "@/utils/getShareInfo";
import { backgroundImages } from "@/utils/backgrounds";

import {
  fastShowGuideEffect,
  fastInitializeGuide,
  showGuideEffect,
  initializeGuide,
  stopGuide,
  BorderShowGuideEffect,
  BorderInitializeGuide,
  BorderStopGuide,
  BorderNOpashShowGuideEffect,
  BorderNOpashInitializeGuide,
  BorderNOpashStopGuide,
  BorderNOpash,
} from "@/utils/guideHelper";
import "@/styles/guideHelper.css";
// 引入组件
import StepNavigation from "@/components/StepNavigation.vue";
import PromptBox from "@/components/PromptBox.vue";
import good from "@/components/good.vue";
import fine from "@/components/fine.vue";
import endHappy from "@/components/endHappy.vue";

// 全局挂载背景图路径对象
Vue.prototype.$backgroundImages = backgroundImages;
//全局挂载背景图路径对象
// Vue.prototype.$wstBackgroundImages = wstBackgroundImages;

// 全局挂载引导效果方法
Vue.prototype.$applyHeights = applyHeights;
Vue.prototype.$showGuideEffect = showGuideEffect;
Vue.prototype.$initializeGuide = initializeGuide;
Vue.prototype.$fastShowGuideEffect = fastShowGuideEffect;
Vue.prototype.$fastInitializeGuide = fastInitializeGuide;
Vue.prototype.$stopGuide = stopGuide;
Vue.prototype.$BorderShowGuideEffect = BorderShowGuideEffect;
Vue.prototype.$BorderInitializeGuide = BorderInitializeGuide;
Vue.prototype.$BorderStopGuide = BorderStopGuide;
Vue.prototype.$BorderNOpashShowGuideEffect = BorderNOpashShowGuideEffect;
Vue.prototype.$BorderNOpashInitializeGuide = BorderNOpashInitializeGuide;
Vue.prototype.$BorderNOpashStopGuide = BorderNOpashStopGuide;
Vue.prototype.$getShareInfo = getShareInfo;
Vue.prototype.$getTxtData = getTxtData;
// 全局注册组件
Vue.component("StepNavigation", StepNavigation);
Vue.component("PromptBox", PromptBox);
Vue.component("good", good);
Vue.component("fine", fine);
Vue.component("endHappy", endHappy);

Vue.config.productionTip = false;

// 加到prototype中，直接通过vue实例就能调用intro了
Vue.prototype.$intro = intro;

// 定义一个全局方法用于播放音频，并且可以管理音频实例
Vue.prototype.$playAudio = function (audioSrc) {
  // 如果有旧的音频实例，先停止它
  if (this.$currentAudio) {
    this.$currentAudio.pause();
    this.$currentAudio.currentTime = 0; // 将播放进度重置为0
  }

  // 创建并播放新的音频
  let audio = new Audio(audioSrc);
  // 使用 then 来确保 play() 成功后再继续其他操作
  audio.muted = true;
  audio
    .play()
    .then(() => {
      // 音频播放成功后，继续执行其他逻辑
      audio.muted = false;
    })
    .catch((error) => {
      console.error("音频播放失败：", error);
      // 播放失败也执行 onended 回调（防止卡住）
      // 即使播放失败，也执行 onended 的逻辑
      if (this.$currentAudio.onended) {
        this.$currentAudio.onended()
      }
    });

  // 保存当前的音频实例
  this.$currentAudio = audio;
};
document.addEventListener("DOMContentLoaded", applyHeights);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
